<template>
  <v-dialog
    v-model="show"
    persistent
    width="500px"
  >
    <v-card>
        <v-card-title class="">
          <div class="font-6 font-weight-bold">Partage du fichier <strong>{{ file.filename }}</strong></div>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template #activator="{on, attrs}">
                <v-btn icon v-on="on" v-bind="attrs" @click="show=false" color="error">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
            <span>Fermer</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-autocomplete 
                v-model="doctors_share" 
                :items="doctors_not_shared" 
                item-text="name" 
                multiple 
                chips
                deletable-chips 
                return-object 
                hide-selected
                label="Partager avec.." 
                placeholder="Partager avec..." 
                outlined
                class="mt-3"
                no-data-text="Pas de docteur"
            >

          </v-autocomplete>
          <div class="my-3 d-flex justify-space-between">
            <v-btn color="primary" style="text-transform: none;" @click="share" :loading="loading">Partager</v-btn>
            <v-btn color="error" style="text-transform: none;" outlined @click="show=false">Annuler</v-btn>
          </div>
          <v-divider></v-divider>
          <v-sheet class="pa-3" min-height="400" >
            <div class="font-weight-bold">
              <v-icon>mdi-account-group</v-icon>
              Médecins ayant accès à ce dossier
            </div>
            <div class="mt-3" v-if="doctors_shared.length">
              
                <v-card v-for="(doctor,i) in doctors_shared" :key="i" class="pa-2 mb-3 grey lighten-3">
                  <div class="d-flex justify-space-between">
                    <div class="font-weight-bold">
                      {{ doctor.name }}
                    </div>
                    <div>
                      <v-btn color="error" elevation="1" class="white--text" style="text-transform: none;" small @click="cancelShare(doctor)">Retirer</v-btn>
                    </div>

                  </div>
                </v-card>
              

            </div>
            <div v-else class="text-center mt-3">
                <div class="font-weight-thin">
                    <div> 
                        <v-icon size="30">mdi-alert-circle-outline</v-icon>
                    </div>
                    
                    Aucun médecin pour le moment
                </div>

            </div>

          </v-sheet>

        </v-card-text>

      </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {file: Object, value: Boolean},
    data() {
        return {
            doctors_not_shared: [],
            doctors_shared: [],
            doctors_share: [],
            loading: false
        }
    },
    mounted() {
    this.notShared()
    this.shared()
  },
    computed: {
        show: {
        get() {
            return this.value;
        },
        set(value) {
            return this.$emit('input', value)
        }
        }
    },
    methods: {
    notShared() {
      this.$http.get(`users/not_shared/${this.file.id}`).then(({ data}) => {
        this.doctors_not_shared = data.doctors
      })
    },
    shared() {
      this.$http.get(`users/shared/${this.file.id}`).then(({ data}) => {
        this.doctors_shared = data.doctors
      })
    },
    share() {
        this.loading = true
        this.errors = {}
        this.$http.post(`users/share/${this.file.id}`, { doctors: this.doctors_share }).then(() => {
          this.notShared()
          this.shared()
          this.doctors_share = []
          this.$toast.success({
            title: 'Partage',
            message: 'Partage du fichier réussi !'
          })
        }).catch((error) => {
          if(error.response.data.errors) {
            this.errors = error.response.data.errors
          } else {
              this.$toast.error({
              title: 'Partage',
              message: 'Impossible de faire le partage car une erreure est survenu'
            })
          }
          
        }).finally(() => this.loading = false)
    },
    cancelShare(doctor) {
        this.$http.delete(`users/cancel_share/${this.file.id}/${doctor.id}`)
        .then(({ data }) => {
            this.doctors_shared = this.doctors_shared.filter((item) => item.id != data.data.id)
            this.$toast.success({
                title: 'Retrait Docteur',
                message: doctor.name+" est rétiré du dossier avec succès !"
            })
        }).catch(() => {
            this.$toast.error({
                title: 'Retrait Docteur',
                message: " Impossible de rétiré $doctor.name du dossier car une erreur est survenue!"
            })
        })
    }
  }
}
</script>

<style>

</style>